import type { Config } from '~/types/models'

export const useConfigStore = defineStore('config', {
  state: () =>
    ({
      websiteTimezone: 'UTC',
      websiteLayout: 'default',
      websiteLogo: null,
      websiteFavicon: null,
      websiteMetaImage: null,
      homepagePageId: null,
      websiteTitle: null,
      websiteDescription: null,
      websiteKeywords: null,
      websiteDisableIndex: true,
      websiteCopyrightText: null,
      websiteTermsOfUseLink: null,
      websitePrivacyPolicyLink: null,
      menus: [],
      kaleidoscopeTicker: null,
      kaleidoscopeConfigured: false,
      googleAnalyticsTag: null,
      googleSiteVerificationCode: null,
      websiteFont: null,
      integrations: {
        intercom: {
          enabled: false,
          widgetId: null,
        },
        termlyIo: {
          enabled: false,
          websiteUuid: null,
        },
      },
      darkTheme: null,
    }) as Config.Model,
})
